import type { Mixpanel } from "@iyk/tracking"

import { EVENT_NAMES, type EventName, type EventProperties, type Tracking } from "./Tracking.ts"

export class MixpanelTracking implements Tracking {
  constructor(private readonly client: Mixpanel.Mixpanel) {}

  registerPostcard(postcardId: string, flow: "Sender" | "Recipient") {
    this.client.register({ postcardId, flow })
  }

  registerPage(page: string) {
    this.client.register({ Page: page })
  }

  track<T extends EventName>(event: T, properties: EventProperties[T], callback?: () => void) {
    const mixpanelEventName = EVENT_NAMES[event]
    return this.client.track(mixpanelEventName, properties, undefined, callback)
  }
}
